<template>
    <label :for="id" :class="classes">
        <input
            :id="id"
            type="checkbox"
            :class="inputClasses"
            :value="value"
            :checked="checked"
            :disabled="disabled"
            @click="click"
            @keydown="keyDown($event)"
        />
        <span :class="mdsNS('form__checkbox-visible-wrap')">
            <span :class="mdsNS('form__checkbox-visual')">
                <svg
                    :class="mdsNS('icon form__checkbox-checked-icon')"
                    aria-hidden="true"
                >
                    <use xlink:href="#check--s"></use>
                </svg>
                <svg
                    :class="mdsNS('icon form__checkbox-indeterminate-icon')"
                    aria-hidden="true"
                >
                    <use xlink:href="#minus--s"></use>
                </svg>
            </span>
            <span :class="mdsNS('form__checkbox-text')"> {{ label }} </span>
        </span>
    </label>
</template>
<script>
import utils from '../../utils';
import mixins from '../mixins';
export default {
    name: 'markets-ui-checkbox',
    mixins: [mixins],
    props: {
        label: String,
        value: {
            type: String,
            required: true
        },
        checked: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: '',
            validator(value) {
                return !value || utils.inArray(['small', 'large'], value) > -1;
            }
        }
    },
    computed: {
        classes() {
            const cls = ['form__checkbox'];
            if (this.size) {
                cls.push(`form__checkbox--${this.size}`);
            }
            if (this.disabled) {
                cls.push('form__checkbox--disabled');
            }
            if (!this.label) {
                cls.push('form__checkbox--hide-label');
            }
            return `${this.namespace()} ${this.mdsNS(cls)}`;
        },
        inputClasses() {
            return [
                this.mdsNS('form__checkbox-input'),
                this.namespace('input')
            ];
        }
    },
    created() {
        this.id = utils.guid();
        this.namespace = utils.namespace('ui-checkbox', false);
    },
    methods: {
        click(e) {
            if (!this.disabled) {
                this.$emit('change', {
                    value: this.value,
                    checked: e.target.checked
                });
            }
        },
        keyDown(e) {
            if (
                utils.keyCode.isSpace(e.keyCode) ||
                utils.keyCode.isEnter(e.keyCode)
            ) {
                e.target.click();
                e.stopPropagation();
                e.preventDefault();
            }
        }
    }
};
</script>
<style lang="scss">
$namespace: 'markets-ui-checkbox';
.#{$namespace} {
    margin: 2px 0;
}
</style>
